import { css } from 'linaria';

export const BoldTitle = css`
	font-weight: 700 !important;
`;

//	!important ^ чтобы переписать стили fronton
